<div class="recover-password-container">
  <div class="recover-password-box">
    <div class="logo">
      <img
        src="assets/images/excuela-logo.svg"
        alt="Excuela Logo"
        class="logo-image"
      />
    </div>

    @if (!emailSent) {
      <p class="recover-password-title">¿Olvidaste tu contraseña?</p>
      <p class="recover-password-description">
        Ingresa tu dirección de correo electrónico y te enviaremos un enlace para restablecer tu contraseña
      </p>
      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="w-full">
        <div class="form-field mb-3">
          <input 
            type="email"
            formControlName="email"
            placeholder="correo@excuela.com"
            autocomplete="email"
            name="email"
            class="form-input">
          <div
            *appFormFieldError="form.get('email'); let errors"
            class="error-message"
          >
            @for (error of errors; track error) {
            <div>{{ error }}</div>
            }
          </div>
        </div>
        <button type="submit" class="submit-button" [disabled]="form.invalid || submitting">
          @if (submitting) {
            <div class="loader-container">
              <div class="spinner"></div>
              <span>Enviando...</span>
            </div>
          } @else {
            Restablecer contraseña
          }
        </button>

        <div class="back-to-login">
          Ir a <a href="/login" class="back-to-login-link">inicio de sesión</a>
        </div>
      </form>
    } @else {
      <p class="recover-password-title">Correo enviado</p>
      <p class="recover-password-description">
        Hemos enviado un correo a <strong>{{ form.value.email }}</strong> para restablecer tu contraseña. Si la cuenta existe, recibirás el mensaje con instrucciones. Revisa también la carpeta de spam.
      </p>
      
      <div class="w-full">
        <button 
          type="button" 
          class="submit-button" 
          (click)="onSubmit()"
          [disabled]="countdown > 0 || submitting">
          @if (submitting) {
            <div class="loader-container">
              <div class="spinner"></div>
              <span>Enviando...</span>
            </div>
          } @else {
            Intentar de nuevo
          }
        </button>

        @if (countdown > 0) {
          <p class="countdown-message">
            ¿No te ha llegado el correo?  <br/>
            Podrás volver a intentar en {{ formatTime(countdown) }}
          </p>
        }

        <div class="back-to-login">
          ¿Este no es tu correo? <span class="back-to-login-link" (click)="changeEmail()">Cambiar correo</span>
        </div>
        <div class="back-to-login">
          Ir a <a href="/login" class="back-to-login-link">inicio de sesión</a>
        </div>
      </div>
    }
  </div>
</div>
